module.exports = __webpack_public_path__ + "img/Fuss_farbig.70a353c.svg";